import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, CanActivateChild } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Injectable()
export class ValidarAdminCerticadas implements CanActivate  {

    paramLogin: string;

    constructor(
        private msalService: MsalUserService, 
        private router: Router,
        private activeRoute: ActivatedRoute) { }

        canActivate() {
            //debugger;
        if (environment.tipoUsuario=='AdministradorCertificadas'|| environment.tipoUsuario=='Administrador') {
           
            return true;
        }
        else
      
        {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado...',
                text: 'Debe ser administrador de ventas certificadas para ingresar a esta opción'
              })
            return false;}
    }
}